// extracted by mini-css-extract-plugin
export default {"upper__container":"TopicsPage_upper__container__+9nTU"};